// extracted by mini-css-extract-plugin
export default {"text_hex":"footer_text_hex__vadRq","text_mlh":"footer_text_mlh__jgqIO","logo":"footer_logo__8RPiu"};